import { Button } from '@tonic-one/react';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { useDisclosure } from '../../../components/Common/Tooltip/TextEllipsis/utils';
import PDFSample from '../PdfSample/PDFSample';

function ViewPDFSampleButton(props: { templateId?: string; format?: string }) {
  const { t } = useTranslation('reportCommon');

  const { templateId = '', format } = props;
  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <Button disabled={templateId === '' || format !== 'pdf'} onClick={onOpen}>
        {t('reportCommon.buttons.viewPDFSample')}
      </Button>
      <PDFSample visible={isOpen} onClose={onClose} templateId={templateId} />
    </>
  );
}

export default memo(ViewPDFSampleButton);
